<style lang="scss">
ul.tabs {
  padding: 0;
  margin: 0;
  display: flex;
  margin: 0;
  border-bottom: 1px solid #e3e3e3;

  &__vertical {
    flex-direction: column;
    border-bottom: none;
    border-right: 1px solid #e3e3e3;
    margin-right: 15px;
  }

  &__right {
    justify-content: end;
  }

  &__bottom {
    align-items: end;
  }
}
</style>

<template>
  <ul class="tabs" :class="[directionClass, alignClass]">
    <slot></slot>
  </ul>
</template>

<script>
import { TabEventBus } from './EventBus.js'

export default {
  name: 'Tabs',
  props: {
    vertical: { type: Boolean },
    right: { type: Boolean },
    bottom: { type: Boolean },
    target: { type: String, required: true }
  },
  provide() {
    return {
      elProp: this.elProp
    }
  },
  data() {
    return {
      elProp: {
        vertical: this.vertical,
        activeTab: null
      }
    }
  },
  computed: {
    directionClass() {
      return {
        tabs__vertical: this.vertical
      }
    },
    alignClass() {
      return {
        tabs__right: this.right,
        tabs__bottom: this.bottom
      }
    }
  },
  mounted() {
    this.$children[0].isActive = true
  },
  methods: {
    deactiveOtherTabs(selectedTab) {
      this.$children
        .filter(tab => tab !== selectedTab)
        .forEach(tab => {
          tab.isActive = false
        })
    }
  },
  watch: {
    'elProp.activeTab': {
      handler(selectedTab) {
        this.deactiveOtherTabs(selectedTab)
        TabEventBus.$emit('tabchange', {
          target: this.target,
          index: this.$children.indexOf(selectedTab)
        })
      }
    }
  }
}
</script>
